import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M16.5 8a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-1.544 5.223a6 6 0 1 0-5.912 0 7.7 7.7 0 0 0-2.981 1.84C4.586 16.54 3.75 18.612 3.75 21a.75.75 0 0 0 1.5 0c0-2.03.705-3.708 1.873-4.876C8.292 14.954 9.97 14.25 12 14.25s3.708.705 4.877 1.874C18.045 17.292 18.75 18.97 18.75 21a.75.75 0 0 0 1.5 0c0-2.388-.836-4.46-2.313-5.937a7.7 7.7 0 0 0-2.981-1.84",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }